import axios from 'axios'
import { useStore } from '@/store'
import { ResponseCode } from './response'

export async function workflowRequest(siteId, method, suffix = '', data, params, area = 'ai-workflows') {
  const response = await axios.request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: `/site/${siteId}/${area}${suffix}`,
    method,
    data,
    params,
    timeout: 30000,
    headers: { Authorization: `Bearer ${useStore().state.user.token}`, 'Content-Type': 'application/json' },
  })
  if (response.data.code !== ResponseCode.SUCCESS) throw new Error(response.data.message || 'Workflow request failed')
  return response.data.data
}
export const siteContentRequest = (siteId, method, suffix = '', data, params) => workflowRequest(siteId, method, suffix, data, params, 'ai-content')
